import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';

/**
 * Route guard for admin routes
 * Redirects to admin login if not authenticated
 */
const AdminRouteGuard = ({ children }) => {
  const { adminUser, isLoading } = useAdminAuth();

  // Show loading while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div>Loading...</div>
      </div>
    );
  }

  // Redirect to admin login if not authenticated
  if (!adminUser) {
    return <Navigate to="/admin/login" replace />;
  }

  // User is authenticated, render children
  return children;
};

export default AdminRouteGuard;
